<template>
  <div class="AnnouncementWrapper">
    <div class="NotificationIconWrapper">
      <Notification />
    </div>
    <div class="AnnouncementText">
      お知らせ：25年10月より送料無料ラインが2,000円→4,000円に変更されます。【キャンペーン終了】
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from "#app";
import { Notification } from '@ka-nabellinc/ka-nabell-icons';
export default defineNuxtComponent({
  components: {
    Notification,
  },
});
</script>

<style scoped>
.AnnouncementWrapper {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 4px;
  padding: 8px 16px;
}

.NotificationIconWrapper {
  width: 24px;
  height: 24px;
}

.AnnouncementText {
  font-size: 11px;
  line-height: 160%;
  letter-spacing: 0.11px;
}
</style>